import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountRegistrationService } from '../../../services/account-registration.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'acc-registration-licence-type',
  templateUrl: './licence-type.component.html',
  styleUrl: './licence-type.component.scss',
})
export class LicenceTypeComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  showAircraftNote: boolean;
  showClubAccount: boolean;

  get formGroupLicenceType() {
    return this.accountRegistrationService.formLicenceType;
  }

  constructor(private readonly accountRegistrationService: AccountRegistrationService) {}

  ngOnInit(): void {
    this.registerShowAircraftNoteListener();
    this.registerShowClubAccountListener();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  registerShowAircraftNoteListener(): void {
    this.subscription.add(
      this.accountRegistrationService.showAircraftNote$.subscribe((showAircraftNote) => {
        this.showAircraftNote = showAircraftNote;
      })
    );
  }

  registerShowClubAccountListener(): void {
    this.subscription.add(
      this.accountRegistrationService.showClubAccount$.subscribe((showClubAccount) => {
        this.showClubAccount = showClubAccount;
      })
    );
  }

  toggleAircraftRadio(checked: boolean) {
    this.accountRegistrationService.setShowAircraftNote(checked);
  }

  toggleClubAccount(checked: boolean) {
    this.accountRegistrationService.setShowClubAccount(checked);
  }
}
